import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { BrandMark } from "../components/Nav";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ phase: "checking", title: "" });
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) {
      setState({ phase: "error", title: "" });
      return;
    }
    let timer;
    const poll = async () => {
      attempts.current += 1;
      try {
        const res = await api.get(`/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          setState({ phase: "paid", title: res.data.artwork_title });
          return;
        }
      } catch {
        /* keep polling */
      }
      if (attempts.current < 15) {
        timer = setTimeout(poll, 2000);
      } else {
        setState({ phase: "timeout", title: "" });
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div
      className="min-h-screen bg-ground text-ink flex flex-col items-center justify-center px-6"
      data-testid="payment-success-page"
    >
      <BrandMark className="w-10 h-10 text-gold mb-8" />
      <span className="mono-tag text-xs uppercase text-gold tracking-widest mb-4">
        THE ABSTRACTS
      </span>

      {state.phase === "checking" && (
        <>
          <h1 className="text-2xl md:text-4xl font-bold uppercase text-white mb-3 text-center">
            Confirming Your Acquisition…
          </h1>
          <p className="text-sm text-slate-400" data-testid="payment-status-text">
            Securing the piece against your payment.
          </p>
        </>
      )}

      {state.phase === "paid" && (
        <>
          <h1 className="text-2xl md:text-4xl font-bold uppercase text-white mb-3 text-center">
            Acquisition Confirmed
          </h1>
          <p className="text-sm text-slate-400 text-center max-w-md" data-testid="payment-status-text">
            {state.title ? `"${state.title}" is now marked acquired in the catalog. ` : ""}
            The studio will contact you to arrange crating and courier delivery.
          </p>
        </>
      )}

      {(state.phase === "timeout" || state.phase === "error") && (
        <>
          <h1 className="text-2xl md:text-4xl font-bold uppercase text-white mb-3 text-center">
            Payment Received — Confirming
          </h1>
          <p className="text-sm text-slate-400 text-center max-w-md" data-testid="payment-status-text">
            Your payment is being verified. The catalog will update shortly;
            check back in a moment.
          </p>
        </>
      )}

      <Link
        to="/"
        className="mt-10 px-6 py-3.5 bg-gold text-black font-semibold uppercase tracking-wider text-xs hover:bg-gold-hover transition-colors"
        data-testid="back-to-gallery-link"
      >
        Back to Gallery
      </Link>
    </div>
  );
}
